module.exports = __webpack_public_path__ + "onboarding-spaces.f0628705ba95e591d4835c5746dbe459.hashedasset.svg";